const UTM_STORAGE_KEY = 'utm_params';
const UTM_EXPIRATION_KEY = 'utm_params_expiration';
const UTM_EXPIRATION_DAYS = 7;
const utms = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_campaignid',
  'utm_adgroupid',
  'gad_source',
  'gad_campaignid',
  'gbraid',
  'gclid'
];

export function getUTMParamsFromURL() {
  const params = new URLSearchParams(window.location.search);
  const result: Record<string, string> = {};
  utms.forEach((key) => {
    if (params.has(key)) result[key] = params.get(key)!;
  });
  return result;
}

export function saveUTMToLocalStorage(params: Record<string, string>) {
  const encodedParams: Record<string, string> = {};
  Object.keys(params).forEach((key) => {
    encodedParams[key] = encodeURIComponent(params[key]);
  });

  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + UTM_EXPIRATION_DAYS);
  localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(encodedParams));
  localStorage.setItem(UTM_EXPIRATION_KEY, expirationDate.toISOString());
}

export function restoreUTMFromLocalStorage(): Record<string, string> | null {
  const raw = localStorage.getItem(UTM_STORAGE_KEY);
  const expiration = localStorage.getItem(UTM_EXPIRATION_KEY);

  if (raw && expiration) {
    const expirationDate = new Date(expiration);
    if (new Date() <= expirationDate) {
      try {
        const decodedParams: Record<string, string> = {};
        const storedParams = JSON.parse(raw);
        Object.keys(storedParams).forEach((key) => {
          decodedParams[key] = decodeURIComponent(storedParams[key]);
        });
        return decodedParams;
      } catch {
        console.error('Failed to parse UTM params from local storage');
        return null;
      }
    } else {
      // Clear expired UTM params
      localStorage.removeItem(UTM_STORAGE_KEY);
      localStorage.removeItem(UTM_EXPIRATION_KEY);
    }
  }
  return null;
}

export function handleUTMParams() {
  const urlParams = getUTMParamsFromURL();

  if (Object.keys(urlParams).length > 0) {
    // Save UTM params if present in the URL
    saveUTMToLocalStorage(urlParams);
  } else {
    // Restore UTM params if missing from the URL
    const stored = restoreUTMFromLocalStorage();
    if (stored) {
      const currentParams = new URLSearchParams(window.location.search);
      utms.forEach((key) => {
        if (!currentParams.has(key) && stored[key]) {
          currentParams.set(key, stored[key]);
        }
      });
      window.history.replaceState({}, '', `${location.pathname}?${currentParams.toString()}`);
    }
  }
}
